import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

type Props = {
  open: boolean;
  title?: string;
  content: string;
  cancelLabel?: string;
  confirmLabel?: string;
  cancelable?: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
  onClose?: () => void;
};

const ConfirmDialog: React.FC<Props> = (props) => {
  return (
    <Dialog open={props.open} onClose={props.onClose} disableEscapeKeyDown>
      <DialogTitle>{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{whiteSpace: "pre-wrap"}}>{props.content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {props.cancelable && (
          <Button variant="outlined" onClick={props.onCancel}>
            {props.cancelLabel}
          </Button>
        )}
        <Button variant="contained" onClick={props.onConfirm} autoFocus>
          {props.confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmDialog.defaultProps = {
  title: '確認',
  cancelLabel: 'キャンセル',
  confirmLabel: 'OK',
  cancelable: false,
};

export default ConfirmDialog;
